'use client';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { UnexpectedError } from '../features/errors';

export interface ErrorBoundaryProviderProps {
  children: ReactNode;
}

export function ErrorBoundaryProvider({ children }: ErrorBoundaryProviderProps) {
  return (
    <ErrorBoundary
      FallbackComponent={UnexpectedError}
      onError={(_error) => {
        //TODO: should this be integrated with Crashlytics or some other error tracking software?
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
